import { Datepicker } from '@insify/design-system/components';
import { RichContentIntro } from '@insify/funnel-components';
import { addDays } from 'date-fns';
import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useContent } from '../../../../hooks/useContent';
import { useConditionsQuery } from '../../../../hooks/useQueries';

import styles from './StartDate.module.css';

import type { IsoDate } from '@insify/global-date';

export const StartDate = () => {
  const { t } = useTranslation(['common', 'funnel']);
  const { checkoutStartDate } = useContent() || {};
  const data = useConditionsQuery().data;

  const { control } = useFormContext();
  const { field, fieldState } = useController({
    // @ts-ignore react-hook-form can't work with dynamic field name
    name: 'startDate',
    control,
  });

  if (!data || !data.startDateBoundariesInDays) {
    return null;
  }
  const dateBoundaries = data.startDateBoundariesInDays;
  const minDate = addDays(new Date(), dateBoundaries[0]);
  const maxDate = addDays(new Date(), dateBoundaries[1]);

  return (
    <>
      <RichContentIntro className={styles.intro} content={checkoutStartDate} />
      <Datepicker
        id='start-date'
        label={t('funnel:checkout_start_date_label')}
        minDate={minDate}
        maxDate={maxDate}
        data-testid='startDate'
        locale='fr'
        trackingId='date'
        onSelect={(value: IsoDate) => {
          field.onChange(value);
        }}
        {...field}
        error={fieldState.error?.message}
      />
    </>
  );
};
